import { Card, Switch, Form, Select, Typography } from "antd";

const { Text } = Typography;

export default function FlowSection({ config, onChange }) {
  const flow = config.flow;

  const update = (key, value) => {
    onChange({
      ...config,
      flow: {
        ...flow,
        [key]: value
      }
    });
  };

  return (
    <Card bordered={false}>
      <Form layout="vertical">

        <Form.Item label="Auto-assign Tables">
          <Switch
            checked={flow.autoAssignTable}
            onChange={(v) => update("autoAssignTable", v)}
          />
          <Text type="secondary">
            Automatically selects the best available table based on party size.
          </Text>
        </Form.Item>

        <Form.Item label="Allow Table Preference">
          <Switch
            checked={flow.allowTablePreference}
            onChange={(v) => update("allowTablePreference", v)}
            disabled={!flow.autoAssignTable}
          />
          <Text type="secondary">
            Guests can request patio, window, etc (not guaranteed).
          </Text>
        </Form.Item>

        <Form.Item label="Default Reservation Status">
          <Select
            value={flow.defaultStatus}
            onChange={(v) => update("defaultStatus", v)}
            options={[
              { value: "confirmed", label: "Confirmed instantly" },
              { value: "pending", label: "Pending (manual review)" }
            ]}
          />
          <Text type="secondary">
            Determines whether bookings need staff approval.
          </Text>
        </Form.Item>

        <Form.Item label="Allow Modification">
          <Switch
            checked={flow.allowModify}
            onChange={(v) => update("allowModify", v)}
          />
          <Text type="secondary">
            Guests can change date/time before arrival.
          </Text>
        </Form.Item>

        <Form.Item label="Allow Cancellation">
          <Switch
            checked={flow.allowCancel}
            onChange={(v) => update("allowCancel", v)}
          />
          <Text type="secondary">
            Guests can cancel reservations online.
          </Text>
        </Form.Item>

      </Form>
    </Card>
  );
}
